import { observer } from "mobx-react";
import { useEffect, useState } from "react";
import store from "../../../_services/store";
import { MoleculeSection, CategorySelector } from "./components";
import { ALPHABET, MOLECULE_SECTION, MOLECULE_TYPE_BY_SECTION } from "../../../constants";
import labels from '../../../_translations/molecules.json';
import { ReactComponent as SearchLogo } from "../../../assets/svg/search.svg";
import {
  Header,
  Main,
  PageTitle,
  SearchInput,
  SearchInputContainer,
} from "../../_ui";

const MoleculesPage = observer(() => {
  const [section, setSection] = useState<TMoleculesListKeys>(MOLECULE_SECTION.CHIMIO);
  const [searchValue, setSearchValue] = useState<string>("");

  useEffect(() => {
    if (store.moleculesList.length === 0) {
      store.getMolecules();
    }
  }, []);

  const prepareMolecules = (moleculesList: TMolecule[]) => {
    const sectionId = MOLECULE_TYPE_BY_SECTION[section];
    // create an array of object with alphabet letter key and an array of molecules starting with this letter
    const moleculesByLetters = ALPHABET.map(key => {
      const moleculesStartWithKey = moleculesList.filter((mol: TMolecule) => (
        mol.type === sectionId || searchValue.length > 0) &&
        mol.title.toUpperCase().startsWith(key) &&
        mol.title.toLowerCase().includes(searchValue)
      );

      if (moleculesStartWithKey.length > 0) {
        return {
          [key]: moleculesStartWithKey
        }
      }
    }).filter(e => e);// clean up undefined

    return moleculesByLetters
  }

  const searchForCriteria = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchValue(e.target.value);
  };

  const molecules = prepareMolecules(store.moleculesList || []);

  const sectionLabels: Record<TMoleculesListKeys, string> = {
    [MOLECULE_SECTION.CHIMIO]: labels[store.currentLanguage].barbtn.btn1,
    [MOLECULE_SECTION.THERAPY]: labels[store.currentLanguage].barbtn.btn2,
    [MOLECULE_SECTION.IMMUNO]: labels[store.currentLanguage].barbtn.btn3,
    [MOLECULE_SECTION.HORMONO]: labels[store.currentLanguage].barbtn.btn4,
  };

  const items = [
    MOLECULE_SECTION.CHIMIO,
    MOLECULE_SECTION.THERAPY,
    MOLECULE_SECTION.IMMUNO,
    MOLECULE_SECTION.HORMONO,
  ].map((category) => ({
    key: category,
    label: sectionLabels[category],
    active: section === category,
    onClick: () => setSection(category),
  }));

  const tabs = searchValue.length === 0 ? <CategorySelector items={items} /> : <></>

  return (
    <div className="fadeIn">
      <Header bgUrl={"/images/bg-molecules.jpeg"}>
        <PageTitle>{labels[store.currentLanguage].title}</PageTitle>
        <SearchInputContainer>
          <SearchLogo />
          <SearchInput
            type="text"
            placeholder={labels[store.currentLanguage].search}
            onChange={searchForCriteria}
          />
        </SearchInputContainer>
      </Header>
      <Main>
        {tabs}
        <div style={{ paddingBottom: '120px' }}>
          {molecules?.map(e => <MoleculeSection key={`Section_${Object.keys(e!)[0]}`} moleculeSection={e} />)}
        </div>
      </Main>
    </div>
  )
});

export default MoleculesPage;